import { render, staticRenderFns } from "./DataTableTotal.vue?vue&type=template&id=2e78b4fe&scoped=true&"
import script from "./DataTableTotal.vue?vue&type=script&lang=ts&"
export * from "./DataTableTotal.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableTotal.vue?vue&type=style&index=0&id=2e78b4fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e78b4fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
